const Payments = ()=>{
    return(
        <>
            <h1>Payments Content</h1>
        </>
    )
}

export default Payments;